module.exports = __webpack_public_path__ + "static/media/wizualizacja-117.12ddf10a.png";